
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#e4f4ff]/20 via-white to-[#b3d9ff]/10"
      style={{
        backgroundImage: `url('/assets/herobackground.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-white/60"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left">
            <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
              <i className="ri-sparkle-line mr-2"></i>
              Intelligent Marketing Revolution
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#22577A] mb-6 leading-tight">
              Agentic AI
              <span className="block text-[#38a3a5]">Marketing Calendar</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
              Transform your social media strategy with intelligent automation. Plan, create, and optimize content across all platforms with our revolutionary marketing calendar.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a href="/signup" className="w-full sm:w-auto">
                <Button variant="primary" size="lg" fullWidth>
                  <i className="ri-rocket-line"></i>
                  Start Free Trial
                </Button>
              </a>
              <Button variant="outline" size="lg" fullWidth className="sm:w-auto">
                <i className="ri-play-circle-line"></i>
                Watch Demo
              </Button>
            </div>

            <div className="flex flex-wrap items-center gap-3 sm:gap-6 text-sm text-gray-600 mb-6">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-[#66b3ff]"></i>
                14-day free trial
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-[#66b3ff]"></i>
                No credit card required
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-[#66b3ff]"></i>
                Cancel anytime
              </div>
            </div>

            {/* Live User Counter */}
            <div className="inline-flex items-center gap-3 px-4 sm:px-6 py-3 bg-white rounded-full shadow-md border border-[#e4f4ff] max-w-full flex-wrap">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#22577A] to-[#38a3a5] flex items-center justify-center text-white text-xs font-bold border-2 border-white">
                  <i className="ri-user-line"></i>
                </div>
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#66b3ff] to-[#b3d9ff] flex items-center justify-center text-white text-xs font-bold border-2 border-white">
                  <i className="ri-user-line"></i>
                </div>
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#38a3a5] to-[#66b3ff] flex items-center justify-center text-white text-xs font-bold border-2 border-white">
                  <i className="ri-user-line"></i>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#22577A] font-bold">Join 50,000+</span>
                <span className="text-gray-600">marketers growing with MandaPost</span>
              </div>
            </div>
          </div>
          
          {/* Right Content - Dashboard Preview */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-6 border border-[#e4f4ff]/30">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-[#22577A]">Marketing Calendar</h3>
                <div className="flex gap-2">
                  <div className="w-3 h-3 bg-[#66b3ff] rounded-full"></div>
                  <div className="w-3 h-3 bg-[#b3d9ff] rounded-full"></div>
                  <div className="w-3 h-3 bg-[#e4f4ff] rounded-full"></div>
                </div>
              </div>
              
              <div className="grid grid-cols-7 gap-2 mb-4">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                  <div key={day} className="text-center text-xs font-medium text-gray-500 py-2">
                    {day}
                  </div>
                ))}
                {Array.from({ length: 35 }, (_, i) => (
                  <div key={i} className="aspect-square border border-gray-100 rounded-lg p-1 relative">
                    {i % 3 === 0 && (
                      <div className="w-full h-2 bg-gradient-to-r from-[#38a3a5] to-[#66b3ff] rounded-sm"></div>
                    )}
                    {i % 5 === 0 && (
                      <div className="w-full h-2 bg-gradient-to-r from-[#66b3ff] to-[#b3d9ff] rounded-sm mt-1"></div>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3 p-3 bg-[#e4f4ff]/20 rounded-lg">
                  <div className="w-8 h-8 bg-[#22577A] rounded-lg flex items-center justify-center">
                    <i className="ri-instagram-line text-white text-sm"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#22577A]">Instagram Story</p>
                    <p className="text-xs text-gray-600">Optimized content ready</p>
                  </div>
                  <div className="w-2 h-2 bg-[#66b3ff] rounded-full"></div>
                </div>
                
                <div className="flex items-center gap-3 p-3 bg-[#b3d9ff]/20 rounded-lg">
                  <div className="w-8 h-8 bg-[#38a3a5] rounded-lg flex items-center justify-center">
                    <i className="ri-linkedin-line text-white text-sm"></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#22577A]">LinkedIn Post</p>
                    <p className="text-xs text-gray-600">Scheduled for 2:00 PM</p>
                  </div>
                  <div className="w-2 h-2 bg-[#b3d9ff] rounded-full"></div>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-gradient-to-br from-[#66b3ff] to-[#b3d9ff] rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-ai-generate text-white text-xl"></i>
            </div>
            
            <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-gradient-to-br from-[#38a3a5] to-[#66b3ff] rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-calendar-check-line text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
